// extracted by mini-css-extract-plugin
export default {"container":"rMAMPUhUmz64lbBCK77z","picture":"ptrDvWd1lhRoEzcFwCfI","text":"dIsXQIDlqWCuzK_w611B","link":"TxtiJAnKI469d1Dg75M4"};